angular.module('7Terminal.Common')
  .service('flashButton', function flashButton() {
    return {
      flash: false
    };
  });
